/**
 * custom-script-sim-load.js
 * 安全率シミュレーター UIコネクター
 * 更新: 2026-06
 * 依存: custom-product-sya-load-calc.js（defer で先行ロード済み）
 */

document.addEventListener('DOMContentLoaded', function () {
  const modelSelect  = document.getElementById('calc-model');
  const wrapperSpan  = document.getElementById('wrapper-span');
  const statusDiv    = document.getElementById('res-status');
  const sfSpan       = document.getElementById('res-sf');
  const matDiv       = document.getElementById('res-mat');

  // 全セレクトに変更イベントを登録
  ['calc-model', 'calc-diameter', 'calc-span', 'calc-height-load', 'calc-load-kg']
    .forEach(function (id) {
      const el = document.getElementById(id);
      if (el) el.addEventListener('change', updateResult);
    });

  function updateResult() {
    if (typeof calculateKuimaruSafety !== 'function') return;

    const currentModel = modelSelect.value;

    // 集中荷重モデルではスパン選択を非表示
    if (wrapperSpan) {
      wrapperSpan.style.display = (currentModel === 'point') ? 'none' : 'block';
    }

    const res = calculateKuimaruSafety(
      document.getElementById('calc-diameter').value,
      parseFloat(document.getElementById('calc-span').value),
      parseFloat(document.getElementById('calc-height-load').value),
      currentModel,
      parseFloat(document.getElementById('calc-load-kg').value)
    );

    if (res.error) {
      statusDiv.innerText = '入力エラー';
      sfSpan.innerText    = '--';
      matDiv.innerText    = '使用鋼材：--'; // ✅ プレフィックス付きでリセット
    } else {
      statusDiv.innerText = '判定：' + res.status;
      sfSpan.innerText    = res.sf;
      matDiv.innerText    = '使用鋼材：' + res.material; // ✅ プレフィックス付きで表示
    }

    statusDiv.style.color = res.color;
    sfSpan.style.color    = res.color;
  }

  // defer順序で calc.js が先に実行済みのため直接呼び出し可
  updateResult();
});